import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackEvent, trackCustom, packEvents } from '../utils/tracking';
import { requestOffer, PackId } from '../utils/offerBus';
interface CtaButtonProps {
  href?: string;
  children: React.ReactNode;
  variant?: 'primary' | 'ghost';
  size?: 'md' | 'lg';
  className?: string;
  icon?: React.ReactNode;
  /** Preselects this pack in the offer section before scrolling back to it. */
  offer?: PackId;
  onClick?: () => void;
}
export function CtaButton({
  href = '#offer',
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  icon,
  offer,
  onClick
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 font-display font-extrabold uppercase tracking-wide transition-[transform,background-color,border-color,color] duration-150 ease-grit focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950';
  const sizing = size === 'lg' ? 'px-8 py-4 text-xl sm:text-2xl' : 'px-5 py-3 text-base';
  const look = variant === 'primary' ? 'bg-grit-500 text-ink-950 hover:bg-grit-400 active:translate-y-[2px]' : 'border-2 border-white/25 text-white hover:border-grit-500 hover:text-grit-500 active:translate-y-[2px]';
  const handleClick = () => {
    trackEvent('AddToCart', {
      content_name: 'GritVue X1'
    });
    if (offer) {
      requestOffer(offer);
      trackCustom(packEvents[offer].addToCart);
    }
    onClick?.();
  };
  return <a href={href} data-buy-intent={href === '#offer' ? 'true' : undefined} onClick={handleClick} className={`${base} ${sizing} ${look} ${className}`} data-id="element-128" data-mp="3swk7do3y8o37">
      {icon}
      <span data-id="element-129" data-mp="6ialpmrelu64">{children}</span>
      {!icon && <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-130" data-mp="6k552wn11e83" />}
    </a>;
}